import Inventory from "./Inventory";

export default Inventory;
export { Inventory };
